<template>
  <div id="accordion">
    <button :class="visible ? 'active' : 'collapsed'" class="button" :aria-expanded="visible ? 'true' : 'false'"
      aria-controls="collapse-4" @click="visible = !visible">
      <span>{{ title }}</span>
      <b-icon v-if="visible" font-scale="1" icon="chevron-up"></b-icon>
      <b-icon v-else font-scale="1" icon="chevron-down"></b-icon>
    </button>
    <b-collapse id="collapse-4" v-model="visible" class="content">
      <b-card class="border-0">
        <div class="d-flex justify-content-center flex-wrap tag-container">
          <Tag v-for="(tag, index) in tags" :key="tag.link || tag.name || index" :tag="tag" />
        </div>
      </b-card>
    </b-collapse>
  </div>
</template>

<script>
import Tag from './Tag.vue';
export default {
  name: 'Accordion',
  props: ['title', 'tags'],
  components: {
    Tag
  },
  data() {
    return {
      visible: false,
    }
  }
}
</script>
<style lang="scss" scope="app/assets/stylesheets/components/accordion"></style>
